const orphanClassesToAvoid = [
	'headline',
	'pretitle',
	'vignette',
	'kicker',
	'subhead',
	'head_guide',
	'subhead_guide',
	'body_head'
];

export function createElement(
	document: Document,
	tagName: string,
	classNames: string | string[] = [],
	innerHTML = ''
): HTMLElement {
	const el = document.createElement(tagName);
	if (typeof classNames === 'string' && classNames) {
		el.classList.add(classNames);
	} else if (Array.isArray(classNames) && classNames.length > 0) {
		el.classList.add(...classNames);
	}

	if (innerHTML) {
		el.innerHTML = innerHTML;
	}
	return el;
}

export function createDivWithContent(
	document: Document,
	classNames: string | string[],
	content: string
): HTMLDivElement | null {
	if (!content) {
		return null;
	}

	const el = document.createElement('div');
	if (typeof classNames === 'string' && classNames) {
		el.classList.add(classNames);
	} else if (Array.isArray(classNames) && classNames.length > 0) {
		el.classList.add(...classNames);
	}

	el.innerHTML = content;
	return el;
}

export function parseHTMLElement(document: Document, htmlString: string): HTMLElement | null {
	if (!htmlString) {
		return null;
	}
	const temp = document.createElement('div');
	temp.innerHTML = htmlString;
	return temp.firstElementChild as HTMLElement | null;
}

export function shouldNotBeOrphan(el: HTMLElement) {
	return (
		el &&
		(el.tagName === 'H2' ||
			el.tagName === 'H3' ||
			orphanClassesToAvoid.some((token) => el?.classList.contains(token)))
	);
}
